import {
  MONITOR_LOAD,
  MONITOR_LOAD_SUCCESS,
  MONITOR_ERROR,
  MONITOR_CLEAN,
  EXPORT_ORDERS,
  EXPORT_ORDERS_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: "",
  orders: [],
  export: null,
  loading: false,
}

const monitor = (state = initialState, action) => {
  switch (action.type) {
    case EXPORT_ORDERS:
      state = {
        ...state,
        export: null,
        loading: true,
        error: "",
      }
      break
    case EXPORT_ORDERS_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        export: action.payload,
      }
      break
    case MONITOR_LOAD:
      state = {
        ...state,
        orders: [],
        loading: true,
        error: "",
      }
      break
    case MONITOR_LOAD_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        orders: action.payload,
      }
      break
    case MONITOR_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break

    case MONITOR_CLEAN:
      state = {
        ...state,
        loading: false,
        error: "",
        orders: [],
        export: null,
      }
      break
  }
  return state
}

export default monitor
